export const habaMyAccountNavigation = {
  myAccountNavigation: {
    customerData: {
      changeLoginData: 'Logindaten ändern',
      changeData: 'Kundendaten ändern',
      label: 'Kundendaten',
      manageAddresses: 'Adressen verwalten',
      kidsDataManagement: 'Kinderdaten verwalten',
    },
    general: {
      article: 'Meine Artikel',
      history: 'Meine Bestellungen',
      overview: 'Meine Übersicht',
      premium: 'Premiumversand',
      return: 'Meine Rücksendungen',
      wishlist: 'Meine Merkliste',
    },
    navigation: {
      heading: 'Account Übersicht',
      orders: 'Meine Bestellungen',
      clientData: 'Meine Kundendaten',
      personalData: 'Persönliche Daten',
      loginData: 'Login Daten',
      billingAddress: 'Rechnungsadresse',
      deliveryAddress: 'Meine Lieferadressen',
    },
  },
};
